import OrderManagement from "./order-management.page";

export default OrderManagement;
